/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
export enum PostfachNachrichtMessageCode {
  PROCESSING_FAILED = 'postfachnachricht.server.processing_failed',
  CONNECTION_FAILED = 'postfachnachricht.server.connection_failed',
  NOT_CONFIGURED = 'postfachnachricht.server.service_not_configured',
  UNKNOWN_POSTFACH_ID = 'postfachnachricht.server.unknown_postfach_id',
}

export const postfachNachrichtMessageCodeMessages = {
  [PostfachNachrichtMessageCode.CONNECTION_FAILED]:
    'Verbindungsfehler: Die Verbindung zum Zielserver des Postfachs ist nicht zustandegekommen.',
  [PostfachNachrichtMessageCode.PROCESSING_FAILED]:
    'Fehlerhafte Verarbeitung: Die Nachricht wurde an das Postfach geschickt, konnte dort aber nicht richtig verarbeitet werden.',
  [PostfachNachrichtMessageCode.NOT_CONFIGURED]: 'Die Nachricht konnte nicht gesendet werden. Es ist kein Postfach konfiguriert.',
  [PostfachNachrichtMessageCode.UNKNOWN_POSTFACH_ID]:
    'Die Nachricht konnte nicht gesendet werden, da das Servicekonto nicht erreichbar ist.',
};
